import OrderAddressBox from 'components/pages/dashboard/ParcelOrder/components/orderAddressPicker/OrderAddressBox';
import OrderClientBox from 'components/pages/dashboard/ParcelOrder/components/orderPersonPicker/OrderClientBox';
import endpointUrls from 'global/Constants/endpointUrls';
import { peopleAddress } from 'global/Models/addressModel';
import { client } from 'global/Models/clientModel';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { packageCreate } from 'global/Models/omOrderModel';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { FC, useCallback, useEffect, useMemo } from 'react';
import { HiOutlineArrowUpOnSquare } from 'react-icons/hi2';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface IOrderOriginSection {
  setPackages: React.Dispatch<React.SetStateAction<packageCreate[]>>;
  index: number;
  packages: packageCreate[];
}

const BranchOrderOriginSection: FC<IOrderOriginSection> = ({ setPackages, index, packages }) => {
  //state
  const { customerUser, userPerson, userProfile } = useSelector((state: RootState) => state.user);

  //effect
  useEffect(() => {
    if (customerUser && userPerson && userProfile) getMyClient();
  }, [userPerson, userProfile, customerUser]);

  //functions
  const addClient = useCallback(
    (client?: client) => {
      setPackages((prevState) => {
        const tempPackages = prevState.map((c, i) => {
          if (i !== index) return c;
          return { ...c, senderClient: client };
        });
        return tempPackages;
      });
    },
    [index, packages]
  );
  const addAddress = useCallback(
    (address?: peopleAddress) => {
      setPackages((prevState) => {
        const tempPackages = prevState.map((a, i) => {
          if (i !== index) return a;
          return { ...a, senderAddress: address, sourceCity: { id: address?.address.cityId, jetId: address?.address.jetCityId } };
        });
        return tempPackages;
      });
    },
    [index, packages]
  );
  const client = useMemo(() => packages[index].senderClient, [packages, index]);
  const address = useMemo(() => packages[index].senderAddress, [packages, index]);

  const getMyClient = async () => {
    await ApiService.post(endpointUrls.clientGetAll, {
      customerId: customerUser?.customerId,
      isDefaultSender: true,
    })
      .then((res: IBackendSearchGeneric<client>) => {
        handleApiThenGeneric<IBackendSearchGeneric<client>, client[]>({
          res,
          notifFail: false,
          notifSuccess: false,
          onSuccessData: (data) => {
            if (data.length > 0) addClient(data[0]);
          },
        });
      })
      .catch(() => localApiCatcher(errorResponse));
  };

  return (
    <div className='flex flex-col gap-2'>
      <span className='flex items-center gap-1 mx-auto font-bold inherit-color text-t-primary-color '>
        <HiOutlineArrowUpOnSquare className='text-xl' /> جمع آوری / فرستنده
      </span>
      <OrderClientBox setClient={addClient} client={client} title='فرستنده' />
      <OrderAddressBox setAddress={addAddress} address={address} peopleAddressTypeId={1} packages={packages} index={index} isNormalOrder={false} />
    </div>
  );
};

export default BranchOrderOriginSection;
